module.exports = __webpack_public_path__ + "img/ramot.28fce643.png";